import * as React from 'react'
import Wait from "../wait";
import ReadService from "../../service/read";
import PopDetail from "../popdetail";
import AllocatePlotPane from "./plot/allocate_plot";
import PlotDetailPane from "./plot/plot_detail_pane";

export default class PlotAllocationPane extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            data: [],
            selected_plots:[],
            description:[],
            deedplan:[]
        }
        this.loadData = this.loadData.bind(this)
        this.pushArray = this.pushArray.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e) {
        e.preventDefault();
        this.setState({[e.target.name]: e.target.value});

        console.log(e.target.value)
        switch (e.target.name) {
            case 'deedplanId':
                this.loadData(e.target.value)
                break
        }
    }
    componentDidMount() {
        this.loadData()
    }


    render() {

        return (<div className={'row'}>
            <div className={'col col-sm-12'} style={{padding:0}}>
                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Plot Allocation
                    </span>



                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

                <div style={{height: '60vh'}}>
                    <div style={{margin:'2% 0 8px 2%'}}>

                        <select style={{width:'10vw',marginLeft:'4px'}} onChange={this.handleChange} name={'deedplanId'}>
                            <option value={0}>- Choose Deed Plan -</option>
                            {this.state.deedplan.map((d,i)=>{
                                return(<option key={i} value={d.id}>{d.name}</option>)
                            })}
                        </select>

                        <input placeholder={'Plot Number....'} style={{width:'40vw',marginLeft:'4px'}}/>



                        <button style={{float: 'right', margin: '0 4%'}} className={'btn submit'} onClick={()=>this.loadData(0)}>
                            <span className={'fa fa-refresh'}/>Refresh
                        </button>

                        <button onClick={()=>PopDetail.show('Allocate '+this.state.selected_plots.length+' Plots',<AllocatePlotPane project={this.props.project} description={this.state.description} deedplan={this.state.selected_plots} loadData={()=>this.loadData(0)}  key={new Date().getMilliseconds()}/>)}
                            className={'btn error'} style={{float:'right',display:this.state.selected_plots.length>0?'inherit':'none'}}>
                            <span className={'fa fa-users'}/>Allocate ({this.state.selected_plots.length})
                        </button>

                    </div>


                    <table className={'tb'} style={{width:'94%',margin:'2%'}}>
                        <thead>
                        <tr>
                            <th style={{width:'50px'}}>#.</th>
                            <th>Created Date</th>
                            <th>Plot Number</th>
                            <th>Use</th>
                            <th>Status</th>
                            <th>Area</th>
                        </tr>
                        </thead>
                        <tbody>

                        {this.state.data.map((d,i)=>{
                            return(<tr key={i} className={'tr'} style={{cursor:'pointer'}} title={d.description}>
                                <td>
                                    <div style={{width:'14px',float:'left'}}>
                                        {i+1}.
                                    </div>
                                    <input defaultChecked={this.state.selected_plots.includes(d.id)} onClick={()=>this.pushArray(d.id,d.claim_no)} type={'checkbox'} style={{marginLeft:'8px'}} />
                                </td>
                                <td>{d.created_date}</td>
                                <td onClick={()=>this.popParcelAt(d)}>
                                    <b style={{color:'darkcyan'}}>{d.claim_no}</b>
                                </td>
                                <td>{d.use}</td>
                                <td>{d.status}</td>
                                <td>{d.area}</td>
                            </tr>)
                        })}
                        </tbody>
                    </table>
                </div>

            </div>


        </div>)
    }


    loadData(deedplan=0) {
        try {
            Wait.show('Fetching Data....')
            ReadService.fetchPlots(this.props.project.id,deedplan,this.props.status).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.results,
                    selected_plots:[],
                    description:[]
                })
            })

           /* ReadService.fetchDeedPlanInfo(this.props.project.id).then(r=>{
                try {
                    this.setState({
                        deedplan:r.data.results
                    })
                }catch (e) {
                    console.log(e)
                }
            })*/
        }catch (e) {
            console.log(e)
        }
    }

    pushArray(id,claim){
        let arr = this.state.selected_plots
        let new_arr = this.state.selected_plots
        let description = this.state.description
        let new_desr = this.state.description

       /* let id = parseInt(e.layer.feature.id.split('.')[1])
        let claim = e.layer.feature.properties.claim_no*/

        if (arr.includes(id)){
            new_arr = []
            new_desr = []
            arr.forEach(it=>{
                if (it!==id){
                    new_arr.push(it)
                }
            })
            description.forEach(it=>{
                if (it!==claim){
                    new_desr.push(claim)
                }
            })
            //selected.setStyle({color: '#f80', weight:4})
        }else{
            //selected.setStyle({color: '#00f', weight:4})
            //map.fitBounds(selected.getBounds())
            new_arr.push(id)
            new_desr.push(claim)
        }

        this.setState({
            selected_plots:new_arr,
            description:new_desr
        })

        setTimeout(()=>{
            console.log(this.state.selected_plots)
        },1000)
    }

    popParcelAt(d) {
        switch (this.props.status) {
            case 'vacant':
                PopDetail.show(d.claim_no+' - '+d.deed_plan,<AllocatePlotPane project={this.props.project} description={[d.claim_no]} deedplan={[d.id]} loadData={()=>this.loadData(0)} key={new Date().getMilliseconds()} screen_code={this.props.screen_code} taskId={this.props.taskId}/>)
                break
            case 'occupied':
                PopDetail.show(d.claim_no,<PlotDetailPane parcel={d} project={this.props.project} screen_code={this.props.screen_code} taskId={this.props.taskId} key={new Date().getMilliseconds()}/>)
                break
        }
    }
}
